export default async ({ store, route }) => {
  const spaceId = route.path.split('/')[2];
  await store.dispatch('coachRoom/getSpaceCoachRooms', {
    spaceID: spaceId,
  });
};
